import type {ParserT} from '@freckle/parser'
import {Parser, merge, record, nullable, string, number} from '@freckle/parser'
import type {RenaissanceKeepaliveT} from '@freckle/educator-entities/ts/common/helpers/renaissance-keepalive'
import {parseKeepaliveAttrs} from '@freckle/educator-entities/ts/common/helpers/renaissance-keepalive'
import StorageHelper from '@freckle/educator-entities/ts/common/helpers/storage-helper'
import type {BaseTeacherAttrs} from '@freckle/educator-entities/ts/users/models/teacher'
import {
  parseTeacherAttrs,
  updateBaseResponseProperties,
} from '@freckle/educator-entities/ts/users/models/teacher'

type TeacherMetadataAttrs = {
  renaissanceKeepalive: RenaissanceKeepaliveT | null | undefined
  districtName: string | null | undefined
  districtId: number | null | undefined
}

export type TeacherAttrs = BaseTeacherAttrs & TeacherMetadataAttrs

const parseTeacherMetadataAttrs: ParserT<TeacherMetadataAttrs> = record({
  renaissanceKeepalive: nullable(parseKeepaliveAttrs),
  districtName: nullable(string()),
  districtId: nullable(number()),
})

export function parse(response: unknown): TeacherAttrs {
  const parseFullAttrs = merge(parseTeacherAttrs, parseTeacherMetadataAttrs)
  const parseFullResponse = Parser.run(response, parseFullAttrs)
  // Hide Teacher's Name and email when in demoMode
  const demoMode = StorageHelper.getLocalStoragePropertyDefault('demoMode', false)
  const updatedResponse = updateBaseResponseProperties(parseFullResponse, demoMode)
  return updatedResponse
}

export const isMathOnly = ({elaStandardSetId}: TeacherAttrs): boolean =>
  elaStandardSetId === null || elaStandardSetId === undefined

export function getTeacherStandardSet(x: {
  teacher: TeacherAttrs
  contentArea: string
}): string | undefined {
  switch (x.contentArea) {
    case 'math':
      return x.teacher.mathStandardSetId
    case 'ela':
      return x.teacher.elaStandardSetId ?? undefined
    default:
      return
  }
}
